















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import FlexibleContentArea from "@/components/layout/FlexibleContentArea.vue";
import ServiceCategoryTabItem from "@/components/service/ServiceCategoryTabItem.vue";
import ServiceCategoryTabMoveButton from "@/components/service/ServiceCategoryTabMoveButton.vue";
import { VIEW_CONFIG } from "@/consts/const";
import { ServiceCategoryInterface } from "@/interfaces/service-category.interface";
import { ViewUtil } from "@/utils/view.util";
import { WindowManager } from "@/view/window-manager";

@Component({
  components: {
    ServiceCategoryTabMoveButton,
    ServiceCategoryTabItem,
    FlexibleContentArea,
  },
})
export default class ServiceCategoryTab extends Vue {
  @Prop({ required: true }) categories!: ServiceCategoryInterface[];
  @Prop({ default: 0 }) categoryId!: number;
  // eslint-disable-next-line
  private tabElem!: HTMLElement;
  private scrollCallback!: () => void;
  private fixed = false;
  private currentTabIndex = 0;
  private tabSizes: number[] = [];
  private windowManager!: WindowManager;
  private isSp = false;

  mounted(): void {
    this.tabElem = this.$refs.tab as unknown as HTMLElement;
    this.tabElem.style.transitionDuration = "0.5s";
    this.setUpFixing();
    this.windowManager = new WindowManager(this.$device);
    this.windowManager.startToWatchWidth((width: number) => {
      const isSp: boolean = width <= VIEW_CONFIG.SP_MAX_WIDTH;

      if ((this.isSp && !isSp) || (!this.isSp && isSp)) {
        this.setUpTabSizes();
        this.moveTab();
      }

      this.isSp = isSp;
    });
  }

  destroyed(): void {
    window.removeEventListener("scroll", this.scrollCallback);
    this.windowManager.stopToWatchWidth();
  }

  @Watch("categories.length")
  private onWatchIds(newValue: number): void {
    this.currentTabIndex = 0;

    if (newValue === 0) {
      this.tabSizes = [];
    } else {
      this.$nextTick(() => {
        this.setUpTabSizes();
        this.correctPosition();
      });
    }
  }

  private correctPosition(): void {
    let currentTabIndex = -1;

    for (let index = 0; index < this.categories.length; index++) {
      if (this.categoryId === this.categories[index].id) {
        currentTabIndex = index;
        break;
      }
    }

    if (currentTabIndex < 1) {
      return;
    }

    this.currentTabIndex = currentTabIndex - 1;
    this.moveTab();
  }

  private setUpTabSizes(): void {
    this.tabSizes = [];

    for (let i = 0; i < this.tabElem.children.length; i++) {
      this.tabSizes.push(
        this.tabElem.children[i].getBoundingClientRect().width
      );
    }
  }

  private setUpFixing(): void {
    const beforeElem: HTMLElement | null = ViewUtil.getBeforeElement(
      this.$el as HTMLElement
    );

    if (beforeElem === null) {
      return;
    }

    this.scrollCallback = (): void => {
      this.fixed =
        ViewUtil.getScrollY() > beforeElem.offsetTop + beforeElem.offsetHeight;
    };
    window.addEventListener("scroll", this.scrollCallback);
    this.scrollCallback();
  }

  private onClick(category: ServiceCategoryInterface): void {
    this.$emit("click", category);
  }

  private onClickPrev(): void {
    this.currentTabIndex--;

    if (this.currentTabIndex < 0) {
      this.currentTabIndex = 0;
    }

    this.moveTab();
  }

  private onClickNext(): void {
    this.currentTabIndex++;

    if (this.currentTabIndex > this.tabSizes.length - 1) {
      this.currentTabIndex = this.tabSizes.length - 1;
    }

    this.moveTab();
  }

  private moveTab(): void {
    this.tabElem.style.transform = `translate(-${this.getCurrentPosition()}px, 0)`;
  }

  private getCurrentPosition(): number {
    let size = 0;

    for (let i = 0; i < this.currentTabIndex; i++) {
      size += this.tabSizes[i];
    }

    return size;
  }
}
